import { Tick } from "../../../core/render/Tick";
/**
 * Draws an axis tick.
 *
 * @see {@link https://www.amcharts.com/docs/v5/charts/xy-chart/axes/#Ticks} for more info
 * @important
 */
export class AxisTick extends Tick {
    constructor() {
        super(...arguments);
        this._tickPoints = [];
    }
}
AxisTick.className = "AxisTick";
AxisTick.classNames = Tick.classNames.concat([AxisTick.className]);
//# sourceMappingURL=AxisTick.js.map